import React from 'react';
import { DataColumnBase } from '../types';

export type CellProps = Pick<
  DataColumnBase,
  'button' | 'maxWidth' | 'minWidth' | 'width' | 'right' | 'center'
>;

export interface BaseCellProps extends CellProps {
  dataTag: string | null;
  id: string;
  children?: React.ReactNode | React.ReactNode[];
}

const BaseCell = ({
  maxWidth,
  minWidth,
  button,
  center,
  right,
  width,
  children,
}: BaseCellProps): JSX.Element => {
  return (
    <div
      className={`relative box-border flex flex-1 flex-shrink-0 items-center px-1 leading-normal ${
        center || button ? 'justify-center' : ''
      } ${right ? 'justify-end' : ''}`}
      style={{
        flexBasis: 0,
        maxWidth: `${width ? width : maxWidth || '100%'}`,
        minWidth: `${width ? width : minWidth || '100px'}`,
        width: `${width ? width : ''}`,
      }}
    >
      {children}
    </div>
  );
};

export default BaseCell;
